import log from "loglevel";
import prefix from "loglevel-plugin-prefix";

prefix.reg(log);
prefix.apply(log, { template: "[%t] %l (%n)" });

// Set by AnalyticsProvider after init to break circular dep
// (analytics/index.js imports logging.js, so we can't import analytics here)
let _analytics = null;
const setAnalytics = (analytics) => { _analytics = analytics; };
const getAnalytics = () => _analytics;

const formatArg = (arg) => {
  if (typeof arg === "string") return arg;
  try {
    const json = JSON.stringify(arg);
    return json === undefined ? String(arg) : json;
  } catch {
    return String(arg);
  }
};

/**
 * Wrap a loglevel logger so that .error() also routes to Analytics.captureError,
 * and add a .withContext(ctx) method for attaching persistent context.
 */
const wrapLogger = (logger, ctx = {}) => {
  const originalError = logger.error.bind(logger);

  const wrapped = Object.create(logger);

  wrapped.error = (...args) => {
    originalError(...args);
    const analytics = getAnalytics();
    if (analytics) {
      // Call sites log `log.error("label: ", error)` — the real Error is rarely args[0],
      // so pick the first Error found anywhere in the args and keep the rest as context.
      const errIndex = args.findIndex((arg) => arg instanceof Error);
      const err = errIndex >= 0 ? args[errIndex] : new Error(String(args[0]));
      const logMessage = args
        .filter((_, i) => i !== errIndex)
        .map(formatArg)
        .join(" ")
        .trim();
      analytics.captureError(err, { ...ctx, logger: logger.name, logMessage });
    }
  };

  wrapped.withContext = (extraCtx) => wrapLogger(logger, { ...ctx, ...extraCtx });

  return wrapped;
};

const getLogger = (loggerName, level = "DEBUG") => {
  const logger = log.getLogger(loggerName);
  logger.setLevel(level);
  return wrapLogger(logger);
};

const api = {
  getLogger,
  setAnalytics,
};

export default api;
